import React, { memo, useMemo } from "react";
import { Container } from "@pixi/react";
import { Settings, GAME_LAYOUT } from "../../settings";
import HoldAndWinOverlayReel from "./HoldAndWinOverlayReel";
import { useReelRefs } from "../../Contexts/ReelRefsContext";

/**
 * HoldAndWinOverlayReelSet - Container for all Hold & Win overlay reels
 * Manages spine animations for coin symbols across all reels
 * Similar to OverlayReelSet but for Hold & Win feature
 *
 * Note: Idle animations are triggered per-symbol in HoldAndWinOverlaySymbol
 * to ensure each symbol's controller is fully initialized before triggering
 */
const HoldAndWinOverlayReelSet = memo(
  ({ symbolWidth, symbolHeight, reelSpacing }) => {
    const { holdAndWinOverlayReelRefs } = useReelRefs();

    // Memoize container Y position
    const containerY = useMemo(
      () => -symbolHeight * (0.5 * Settings.SYMBOLS_VISIBLE - 0.5),
      [symbolHeight]
    );

    return (
      <Container
        name="hold_and_win_overlay"
        zIndex={7}
        y={containerY}
      >
        {GAME_LAYOUT.REEL_INDICES.map((index) => (
          <HoldAndWinOverlayReel
            key={index}
            symbolHeight={symbolHeight}
            symbolWidth={symbolWidth}
            reelSpacing={reelSpacing}
            ref={(el) => {
              holdAndWinOverlayReelRefs.current[index] = el;
            }}
            index={index}
          />
        ))}
      </Container>
    );
  }
);

export default HoldAndWinOverlayReelSet;
